var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 589,
    viewBox: "0 0 586 589",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4 0H0V350.5H32.4V0Z",
    transform: "translate(0.5 168.8)",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H0V373.4H35V0Z",
    transform: "translate(15.3999 128.6)",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 137.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 147.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 158)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 168.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 178.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 189)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 199.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 209.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 220)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 230.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 240.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 251)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 261.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 271.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 282)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21",
    transform: "translate(22.3999 292.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8 0H0V256.9H77.8V0Z",
    transform: "translate(109.7 250.9)",
    fill: "url(#paint2_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.2V0H8.59999V11.2H0V28.2H25.6V11.2H17Z",
    transform: "translate(135.8 222.7)",
    fill: "url(#paint3_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.1",
    transform: "translate(118.9 271.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.1",
    transform: "translate(153.2 271.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.1",
    transform: "translate(118.9 283.2)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.1",
    transform: "translate(153.2 283.2)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.1",
    transform: "translate(118.9 294.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.1",
    transform: "translate(153.2 294.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7 0H0V235.9H33.7V0Z",
    transform: "translate(177.3 283.4)",
    fill: "url(#paint4_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 12.6V0H5.3V12.6H0V200H31.9V12.6H12.9Z",
    transform: "translate(145.5 325.2)",
    fill: "url(#paint5_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.7",
    transform: "translate(152.1 350.9)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.7",
    transform: "translate(152.1 366.4)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.7",
    transform: "translate(152.1 382)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.7",
    transform: "translate(152.1 397.5)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.7",
    transform: "translate(152.1 413.1)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 0H0V242.8H28.9V0Z",
    transform: "translate(60.7002 272.8)",
    fill: "url(#paint6_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H0V139.4H27.5V0Z",
    transform: "translate(311.3 424.3)",
    fill: "url(#paint7_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 0H0V211H30.8V0Z",
    transform: "translate(38.9004 301.9)",
    fill: "url(#paint8_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H0V139.4H22.5V0Z",
    transform: "translate(56.3003 372.9)",
    fill: "url(#paint9_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 0H0V152.9H36.2V0Z",
    transform: "translate(10.7002 347.4)",
    fill: "url(#paint10_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 0H9.10001L0 14V138.4H30.7V14L21.6 0Z",
    transform: "translate(288.9 386.2)",
    fill: "url(#paint11_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H0V11.7H4.5V0Z",
    transform: "translate(295.3 403.8)",
    fill: "url(#paint12_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H0V11.7H4.5V0Z",
    transform: "translate(308.7 403.8)",
    fill: "url(#paint13_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H0V11.7H4.5V0Z",
    transform: "translate(295.3 436.8)",
    fill: "url(#paint14_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H0V11.7H4.5V0Z",
    transform: "translate(308.7 436.8)",
    fill: "url(#paint15_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H0V11.7H4.5V0Z",
    transform: "translate(295.3 469.9)",
    fill: "url(#paint16_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H0V11.7H4.5V0Z",
    transform: "translate(308.7 469.9)",
    fill: "url(#paint17_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 16.8C10.3 16.8 2.39999 11.5 2.39999 0H0C0 0 0.099988 18.7 9.29999 25.5C18.5 32.3 10.3 16.8 10.3 16.8Z",
    transform: "translate(353.7 453.8)",
    fill: "url(#paint18_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 0H0V26.9H23.3V0Z",
    transform: "translate(358.5 525.8)",
    fill: "url(#paint19_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 0H0V4.29999H31.7V0Z",
    transform: "translate(354.3 521.5)",
    fill: "url(#paint20_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 0H0V4.29999H28.8V0Z",
    transform: "translate(355.8 517.2)",
    fill: "url(#paint21_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 0H0V4.29999H25.6V0Z",
    transform: "translate(357.4 512.8)",
    fill: "url(#paint22_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 41.4H0L0.5 32.1C8.4 29.3 12.5 16 14.3 7.39999C15.2 3.09999 15.6 0 15.6 0C16.1 0.9 16.4 2.00001 16.5 3.10001L18.4 41.4Z",
    transform: "translate(360.9 471.4)",
    fill: "url(#paint23_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 1.5C15.1 1.5 14.7 4.59999 13.8 8.89999C12 17.5 7.9 30.8 0 33.6L0.700012 19.4C5.20001 16.9 8.20002 13.2 10.3 9.70001C10.7 9.00001 11.1 8.30001 11.4 7.70001C13.4 3.50001 14 0 14 0C14.5 0.5 14.8 0.9 15.1 1.5Z",
    transform: "translate(361.4 470)",
    fill: "url(#paint24_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 4.80002C10.4 5.50002 10 6.10002 9.60001 6.80002C7.60001 10.3 4.5 14 0 16.5L0.799988 1.70001C0.799988 1.10001 0.900006 0.5 1.10001 0L8.69998 3.89999L10.7 4.80002Z",
    transform: "translate(362.1 472.9)",
    fill: "url(#paint25_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 2.29999C12.2 2.29999 11.6 5.8 9.59998 10L7.59998 9L0 5.09998C0.9 2.09998 3.69999 0 6.89999 0C8.99999 0 10.9 0.899988 12.2 2.29999Z",
    transform: "translate(363.2 467.7)",
    fill: "url(#paint26_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40002 12.8C9.93465 12.8 12.8 9.93465 12.8 6.40002C12.8 2.8654 9.93465 0 6.40002 0C2.8654 0 0 2.8654 0 6.40002C0 9.93465 2.8654 12.8 6.40002 12.8Z",
    transform: "translate(363.8 457.3)",
    fill: "url(#paint27_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.39999L1.5 6L6.29999 0L0 4.39999Z",
    transform: "translate(374.2 454)",
    fill: "url(#paint28_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.59998L2 7.5L4.10001 0L0 6.59998Z",
    transform: "translate(371.8 450.7)",
    fill: "url(#paint29_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.60001L2.19998 7.70001L1.19998 0L0 7.60001Z",
    transform: "translate(369.2 449.5)",
    fill: "url(#paint30_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80002 7.60001L3.89999 6.70001L0 0L1.80002 7.60001Z",
    transform: "translate(364.9 450.5)",
    fill: "url(#paint31_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69998 6.29999L6.19998 4.69998L0 0L4.69998 6.29999Z",
    transform: "translate(360.1 453.6)",
    fill: "url(#paint32_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09998 10.3H0.899994L0 0H4L3.09998 10.3Z",
    transform: "translate(353.2 446.6)",
    fill: "url(#paint33_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 9.20001C10.2 6.40001 5.10001 0 5.10001 0C5.10001 0 0 6.40001 0 9.20001C0 12 2.30001 14.3 5.10001 14.3C7.90001 14.3 10.2 12 10.2 9.20001Z",
    transform: "translate(350.1 432.9)",
    fill: "url(#paint34_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79999 12.2C1.69999 12.2 0 10.5 0 8.39999V3.80002C0 1.70002 1.69999 0 3.79999 0C5.89999 0 7.60001 1.70002 7.60001 3.80002V8.39999C7.50001 10.5 5.89999 12.2 3.79999 12.2Z",
    transform: "translate(373.1 472.4)",
    fill: "url(#paint35_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60001 5.20001C4.03595 5.20001 5.20001 4.03595 5.20001 2.60001C5.20001 1.16407 4.03595 0 2.60001 0C1.16407 0 0 1.16407 0 2.60001C0 4.03595 1.16407 5.20001 2.60001 5.20001Z",
    transform: "translate(376.5 482)",
    fill: "url(#paint36_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59998 5.20001C4.03592 5.20001 5.19998 4.03595 5.19998 2.60001C5.19998 1.16407 4.03592 0 2.59998 0C1.16404 0 0 1.16407 0 2.60001C0 4.03595 1.16404 5.20001 2.59998 5.20001Z",
    transform: "translate(351.7 452.8)",
    fill: "url(#paint37_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 0L0 0.0999985V93.7H2.6V0Z",
    transform: "translate(109.4 85)",
    fill: "#FFAD1A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 0H0V268H36.4V0Z",
    transform: "translate(92.5 231.4)",
    fill: "url(#paint38_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 0H0V268H15.7V0Z",
    transform: "translate(84.6001 231.4)",
    fill: "url(#paint39_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 0H0V268H15.7V0Z",
    transform: "translate(121.1 231.4)",
    fill: "url(#paint40_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.2H0.799995V50.9H34V17.2H34.8V0H0Z",
    transform: "translate(93.3003 180.5)",
    fill: "url(#paint41_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 0H0V33.6H15.7V0Z",
    transform: "translate(87.2002 197.7)",
    fill: "url(#paint42_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 0H0V33.6H15.7V0Z",
    transform: "translate(118.5 197.7)",
    fill: "url(#paint43_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 0H0V16.6H5.2V0Z",
    transform: "translate(92.5 206.2)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 0H0V16.6H5.2V0Z",
    transform: "translate(123.7 206.2)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 0H0V12.4H26.1V0Z",
    transform: "translate(97.7002 168.1)",
    fill: "url(#paint44_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 0H0V3.40001H22.8V0Z",
    transform: "translate(99.3003 164.7)",
    fill: "url(#paint45_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 0H0V24.8H10.9V0Z",
    transform: "translate(105.2 139.9)",
    fill: "url(#paint46_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.9",
    transform: "translate(92.5 412.9)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.9",
    transform: "translate(92.5 337.6)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.9",
    transform: "translate(92.5 262.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.9",
    transform: "translate(128.9 412.9)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.9",
    transform: "translate(128.9 337.6)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.9",
    transform: "translate(128.9 262.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V192.8",
    transform: "translate(110.7 250.5)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0H0V27.2H5V0Z",
    transform: "translate(108.2 191.6)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M182.9 0C167 34.1 131.8 57.1 91.6 57.1C51.4 57.1 15.9 34.6 0 0.5",
    transform: "translate(40.2998 417.4)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0H0V78.4H9.6V0Z",
    transform: "translate(31.5 416.8)",
    fill: "url(#paint47_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59999 0H0V91.2H9.59999V0Z",
    transform: "translate(222.3 416.8)",
    fill: "url(#paint48_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M237.2 0H0V6.20001H237.2V0Z",
    transform: "translate(0.5 476.5)",
    fill: "url(#paint49_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M183.2 0C167.3 34.1 132.1 57.1 91.9 57.1C51.7 57.1 15.9 34.6 0 0.5",
    transform: "translate(19 417.4)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0H0V78.4H9.6V0Z",
    transform: "translate(10.6001 416.8)",
    fill: "url(#paint50_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59999 0H0V91.2H9.59999V0Z",
    transform: "translate(201.3 416.8)",
    fill: "url(#paint51_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V35H2V0Z",
    transform: "translate(262.4 170.3)",
    fill: "url(#paint52_linear)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39999 0C4.19999 0 0 4.19999 0 9.39999V23.8H18.7V9.39999C18.7 4.09999 14.6 0 9.39999 0Z",
    transform: "translate(254 193.5)",
    fill: "url(#paint53_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.8 0 0 5.8 0 13V33.1H26.1V13C26 5.9 20.2 0 13 0Z",
    transform: "translate(250.4 204.7)",
    fill: "url(#paint54_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V3.40001",
    transform: "translate(263.4 206.9)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.60001 2.90001",
    transform: "translate(258 208.4)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69998 0L0 2.90001",
    transform: "translate(267.101 208.4)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 0C6.8 0 0 6.8 0 15.2V38.6H30.4V15.2C30.4 6.8 23.6 0 15.2 0Z",
    transform: "translate(248.2 214.2)",
    fill: "url(#paint55_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V3.90001",
    transform: "translate(263.4 216.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.89999 3.40001",
    transform: "translate(257.101 218.4)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90002 0L0 3.40001",
    transform: "translate(267.8 218.4)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.6 0 0 7.6 0 17V43.2H34.1V17C34 7.6 26.4 0 17 0Z",
    transform: "translate(246.4 225)",
    fill: "url(#paint56_linear)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V4.40001",
    transform: "translate(263.4 227.9)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.2 3.8",
    transform: "translate(256.3 229.8)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.79999 2.2",
    transform: "translate(251.101 235)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80002 0L0 2.2",
    transform: "translate(271.9 235)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20001 0L0 3.8",
    transform: "translate(268.3 229.8)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0C8.3 0 0 8.3 0 18.5V47H37V18.5C37 8.3 28.7 0 18.5 0Z",
    transform: "translate(244.9 238.5)",
    fill: "url(#paint57_linear)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V4.7",
    transform: "translate(263.4 241.6)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.40001 4.10001",
    transform: "translate(255.7 243.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.09999 2.39999",
    transform: "translate(250.101 249.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10001 0L0 2.39999",
    transform: "translate(272.601 249.3)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39999 0L0 4.10001",
    transform: "translate(268.7 243.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 245.3L0 244.5V0H51.3V245.3Z",
    transform: "translate(237.7 277.1)",
    fill: "url(#paint58_linear)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V157.6",
    transform: "translate(251.3 289.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V157.6",
    transform: "translate(263.3 289.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V157.6",
    transform: "translate(275.3 289.7)",
    stroke: "#FBAC1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M65 7.6C62 7.6 59.2 8.7 57.1 10.6C53.8 4.3 47.3 0 39.7 0C30.7 0 23.1 6.1 20.8 14.4C18.6 12 15.5 10.5 12 10.5C5.4 10.5 0 15.9 0 22.5C0 29.1 5.4 34.5 12 34.5C16.4 34.5 20.2 32.1 22.3 28.6C25.6 34.9 32.1 39.2 39.7 39.2C47.3 39.2 53.8 34.9 57.1 28.6C59.2 30.4 61.9 31.6 65 31.6C71.6 31.6 77 26.2 77 19.6C77 12.9 71.6 7.6 65 7.6Z",
    transform: "translate(145.3 66.5)",
    fill: "url(#paint59_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6 12.5C88.5 12.5 86.6 13.3 85.2 14.6C83 10.2 78.5 7.3 73.3 7.3C70.6 7.3 68.1 8.1 65.9 9.5C62.2 3.8 55.8 0 48.5 0C42.2 0 36.6 2.8 32.8 7.3C30.4 5.8 27.6 4.9 24.6 4.9C18.7 4.9 13.6 8.2 11 13C10.1 12.7 9.1 12.5 8.1 12.5C3.6 12.5 0 16.1 0 20.6C0 25.1 3.6 28.7 8.1 28.7C9.2 28.7 10.3 28.5 11.3 28C14 32.5 18.9 35.6 24.5 35.6C27.4 35.6 30 34.8 32.3 33.4C36.1 38.1 41.9 41.1 48.4 41.1C55.7 41.1 62.1 37.3 65.7 31.6C67.8 33 70.3 33.8 73.1 33.8C78.3 33.8 82.8 30.8 85 26.5C86.4 27.8 88.3 28.6 90.4 28.6C94.9 28.6 98.5 25 98.5 20.5C98.7 16.1 95 12.5 90.6 12.5Z",
    transform: "translate(36.6001)",
    fill: "url(#paint60_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M261.6 17.7C331.7 27.8 491.3 84.3 585 100.9H0V0C0 0 179.2 5.90001 261.6 17.7Z",
    transform: "translate(0.5 491.9)",
    fill: "url(#paint61_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-97.5737 77.0213) scale(227.555) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-307.502 300.221) scale(650.02) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.1547 85.0148) scale(176.045) rotate(-88.698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-16.1967 30.788) scale(58.001) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-184.554 156.921) scale(402.756) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-74.6573 138.288) scale(181.177) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-169.257 94.013) scale(367.505) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-72.5443 40.0213) scale(172.642) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-87.9556 75.6713) scale(206.772) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-53.2701 63.2546) scale(129.035) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.4236 78.144) scale(161.011) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-102.061 142.288) scale(234.859 234.859) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-70.3248 144.013) scale(145.104 145.104) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-70.2425 144.013) scale(145.104 145.104) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-70.3248 111.013) scale(145.104 145.104) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-70.2425 111.013) scale(145.104 145.104) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-70.3248 77.9131) scale(145.104 145.104) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-70.2425 77.9131) scale(145.104 145.104) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.7671 33.1046) scale(28.7067) rotate(-124.174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0194 1.8551) scale(23.2808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.026 -13.6552) scale(31.6676 31.6675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.8053 -12.2472) scale(28.7756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.4626 -10.5946) scale(25.5944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9.76335 45.2547) scale(38.0443) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17.8664 25.5485) scale(35.8255) rotate(-60.4535)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0572004 16.8584) scale(15.9068) rotate(-125.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.900299 9.42265) scale(9.68955) rotate(-86.0546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.31756 25.0213) scale(23.3547) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.53673 28.3213) scale(23.3547) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9.62156 31.6213) scale(23.3547) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-10.604 32.8214) scale(23.3545 23.3547) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9.77384 31.8213) scale(23.3547) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.53372 28.7212) scale(23.3546) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.0196 3.12825) scale(4.0673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.26089 22.1713) scale(18.75) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0234 2.39935) scale(7.51931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.015 0.0344501) scale(5.19551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0282999 0.0184) scale(5.19538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-122.554 194.905) scale(281.516) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-114.17 233.399) scale(244.1) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-114.223 233.399) scale(244.1) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.538 34.0545) scale(41.8834) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15.2855 36.4712) scale(46.3175) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15.3246 36.4712) scale(46.3175) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.8146 16.6545) scale(22.3782) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.32035 5.22121) scale(6.1667) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.65045 33.1545) scale(26.3083) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-45.1708 50.688) scale(100.02) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-45.2266 50.188) scale(100.02 100.02) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.07 11.6546) scale(17.013) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.6976 135.513) scale(135.004) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.6533 135.513) scale(135.004 135.004) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-24.9569 41.5042) scale(51.8939) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.82945 27.2416) scale(30.4389) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.1925 38.0245) scale(42.365) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9.51615 44.2824) scale(49.4123) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-10.6977 49.6651) scale(55.3753) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.6027 53.9313) scale(60.1854) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-113.042 189.07) scale(277.465) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-51.1075 40.809) scale(179.327) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-42.4244 43.3713) scale(183.551) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.479 77.2695) scale(238.034) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.4dbed37b7f7e91c03679230983b9780b.svg";
export { ForwardRef as ReactComponent };